import { createStyles } from '@mantine/core'
type StyleParams = {
  backgroundColor: string
  icon: string
}

export default createStyles((theme, { backgroundColor }: StyleParams) => {
  return {
    root: {
      backgroundColor: backgroundColor || '#fff',
      borderRadius: 16,
      border: `1px solid ${backgroundColor || theme.colors.neutral[0]}`,
      padding: 16,
      boxShadow:
        '0px 0px 1px 0px #0000000A, 0px 2px 8px 0px #0000000A, 0px 16px 24px 0px #0000000F',
      '.odometer.odometer-auto-theme, .odometer.odometer-theme-default': {
        fontFamily: 'unset',
        lineHeight: 'unset',
      },
    },
    inner: { height: '100%' },
    info: { flexGrow: 1 },
    icon: {
      width: 56,
      height: 56,
      flexShrink: 0,
    },
  }
})
